import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { OrderService } from "./order.service";
import { OOVenueService } from "./venue-service";

@Injectable({
	providedIn: "root",
})
export class CheckoutGuardService implements CanActivate {
	constructor(private venueService: OOVenueService, private orderService: OrderService) {}

	async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return true;
		if (this.orderService.activeOrder.value.checkKey) {
			return true;
		}
		return false;
	}
}
